<button
  mat-icon-button
  [matMenuTriggerFor]="approvalMenu"
  (click)="$event.stopPropagation()"
  data-cy="approval-menu-btn"
  data-testid="approval-menu-btn"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #approvalMenu="matMenu">
    <ng-container *ngFor="let item of approvalMenuItems">
    <button mat-menu-item 
    [disabled]="!item.enabled"
    (click)="item.onClick()"
    *ngIf="item.isVisible"
    [attr.data-cy]="'approval menu ' + item.text + ' btn' | lowercase | kebabcase"
    [attr.data-testid]="'approval menu ' + item.text + ' btn' | lowercase | kebabcase"
    >{{item.text}}</button>
</ng-container>
</mat-menu>
